import React from "react";
import { bool, func } from "prop-types";

import { CheckboxButton } from "../../../common";

const DrivingLicense = ({ value, toggleSelected }) => (
  <div className="mt-2">
    Do you have a valid UK driving licence?*
    <div className="btn-group clearfix d-flex" style={{ marginTop: "10px" }}>
      <CheckboxButton
        isChecked={value}
        onClick={() => toggleSelected("driver", true)}
        label="Yes"
        width="50%"
      />
      <CheckboxButton
        isChecked={!value && value !== ""}
        onClick={() => toggleSelected("driver", false)}
        label="No"
        width="50%"
      />
    </div>
  </div>
);

DrivingLicense.propTypes = {
  value: bool,
  toggleSelected: func.isRequired,
};

export default DrivingLicense;
